export default "__VITE_ASSET__0afbfa0f__"